import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.panel', {
      p: 32,
      my: 24,
      borderRadius: 'card',
      // boxShadow: 'level1',
      background: 'white',
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
    }),
  ]
}
